import { Pipe, PipeTransform } from "@angular/core";
      
      @Pipe({
    name: 'boolToDisplayValue',
    standalone: false
})
      export class BoolToDisplayValuePipe implements PipeTransform {
          transform(value?: boolean, trueVal: string = 'Yes', falseVal: string = 'No'): string {
              if (value == null) {
                  return '';
              }
              return value ? trueVal : falseVal;
          }
      }